import { context } from '@wikia/ad-engine';

export function getKargoContext(): object {
	const floorAdhesionConfigs = context.get('experiments.persistentAdhesionExperiment')
		? {
				adhesion_limited: {
					sizes: [[320, 50]],
					placementId: '_eCUP2gxE2l',
				},
			}
		: {
				floor_adhesion: {
					sizes: [[320, 50]],
					placementId: '_t6KTOnCSj5',
				},
			};

	return {
		enabled: false,
		slots: {
			mobile_in_content: {
				sizes: [[300, 250]],
				placementId: '_oMn9XHKEp3',
			},
			...(context.get('kargo.floorAdhesion') ? floorAdhesionConfigs : {}),
		},
	};
}
